import Welcome from '~/pages/welcome'
import Login from '~/pages/auth/login'
import Register from '~/pages/auth/register'
import PasswordEmail from '~/pages/auth/password/email'
import PasswordReset from '~/pages/auth/password/reset'
import NotFound from '~/pages/errors/404'
import Home from '~/pages/home'
import Settings from '~/pages/settings/index'
import SettingsProfile from '~/pages/settings/profile'
import SettingsPassword from '~/pages/settings/password'
import Admin from '~/pages/admin/index'
import AdminUsers from '~/pages/admin/users/index'
import AdminUsersForm from '~/pages/admin/users/form'
import AdminCompanies from '~/pages/admin/companies/index'
import AdminCompaniesForm from '~/pages/admin/companies/form'
import AdminCategoriesForm from '~/pages/admin/categories/form'
import AdminPrintableTypes from '~/pages/admin/printabletypes/index'
import AdminPrintableTypesForm from '~/pages/admin/printabletypes/form'
import AdminTemplates from '~/pages/admin/templates/index'
import AdminTemplatesForm from '~/pages/admin/templates/form'
import AdminProjects from '~/pages/admin/projects/index'
import AdminProjectsForm from '~/pages/admin/projects/form'
import Printables from '~/pages/printables/index'
import PrintablesForm from '~/pages/printables/form'
import PrintablesOrderForm from '~/pages/printables/order-form'
import External from '~/pages/external/index'
import Assemble from '~/pages/assemble'
import Components from '~/pages/components/index'
import ComponentsForm from '~/pages/components/form'

export default [
  { path: '/', redirect: { name: 'login' } },

  { path: '/login', name: 'login', component: Login },
  { path: '/register', name: 'register', component: Register },
  { path: '/password/reset', name: 'password.request', component: PasswordEmail },
  { path: '/password/reset/:token', name: 'password.reset', component: PasswordReset },

  { path: '/home', name: 'home', component: Home },
  { path: '/settings',
    component: Settings,
    children: [
      { path: '', redirect: { name: 'settings.profile' } },
      { path: 'profile', name: 'settings.profile', component: SettingsProfile },
      { path: 'password', name: 'settings.password', component: SettingsPassword }
    ] },
  { path: '/admin',
    component: Admin,
    children: [
      { path: '', redirect: { name: 'admin.users' } },

      { path: 'users', name: 'admin.users', component: AdminUsers },
      { path: 'users/create', name: 'admin.users.create', component: AdminUsersForm },
      { path: 'users/:id', name: 'admin.users.id', component: AdminUsersForm },
      { path: 'users/:id/edit', name: 'admin.users.id.edit', component: AdminUsersForm },

      { path: 'companies', name: 'admin.companies', component: AdminCompanies },
      { path: 'companies/create', name: 'admin.companies.create', component: AdminCompaniesForm },
      { path: 'companies/:id', name: 'admin.company.id', component: AdminCompaniesForm },
      { path: 'companies/:id/edit', name: 'admin.company.id.edit', component: AdminCompaniesForm },

      { path: 'categories/create', name: 'admin.categories.create', component: AdminCategoriesForm },
      { path: 'categories/:id', name: 'admin.categories.id', component: AdminCategoriesForm },
      { path: 'categories/:id/edit', name: 'admin.categories.id.edit', component: AdminCategoriesForm },

      { path: 'printabletypes', name: 'admin.printabletypes', component: AdminPrintableTypes },
      { path: 'printabletypes/create', name: 'admin.printabletypes.create', component: AdminPrintableTypesForm },
      { path: 'printabletypes/:id', name: 'admin.printabletypes.id', component: AdminPrintableTypesForm },
      { path: 'printabletypes/:id/edit', name: 'admin.printabletypes.id.edit', component: AdminPrintableTypesForm },

      { path: 'projects', name: 'admin.projects', component: AdminProjects },
      { path: 'projects/create', name: 'admin.projects.create', component: AdminProjectsForm },
      { path: 'projects/:id', name: 'admin.projects.id', component: AdminProjectsForm },
      { path: 'projects/:id/edit', name: 'admin.projects.id.edit', component: AdminProjectsForm },

      { path: 'templates', name: 'admin.templates', component: AdminTemplates },
      { path: 'templates/create', name: 'admin.templates.create', component: AdminTemplatesForm },
      { path: 'templates/:id', name: 'admin.templates.id', component: AdminTemplatesForm },
      { path: 'templates/:id/edit', name: 'admin.templates.id.edit', component: AdminTemplatesForm }
    ] },
  { path: '/printables', name: 'printables', component: Printables },
  { path: '/printables/create', name: 'printables.create', component: PrintablesForm },
  { path: '/printables/order', name: 'printables.order', component: PrintablesOrderForm },
  { path: '/printables/:id', name: 'printables.id', component: Printables },
  { path: '/printables/:id/assemble', name: 'printables.id.assemble', component: Printables },
  { path: '/printables/:id/edit', name: 'printables.id.edit', component: PrintablesForm },

  { path: '/external', name: 'external', component: External },

  { path: '/assemble/:id', name: 'assemble', component: Assemble },

  { path: '/components', name: 'components', component: Components },
  { path: '/components/create', name: 'components.create', component: ComponentsForm },
  { path: '/components/:id', name: 'components.id', component: Components },
  // { path: '/components/:id/edit', name:'components.id.edit', component: ComponentsForm },

  { path: '*', component: NotFound }
]



// WEBPACK FOOTER //
// ./resources/assets/js/router/routes.js